import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Defer hydration until after the static prerender has painted so LCP
// fires on the server-sent <img>, not the React-recreated one.
const mount = () => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('requestIdleCallback' in window) {
  requestIdleCallback(mount, { timeout: 200 });
} else {
  setTimeout(mount, 0);
}
